import { Component, Inject, OnInit } from '@angular/core';
import { FacadeService } from 'src/app/services/FacadeService';
import { Project } from 'src/models';
import * as moment from 'moment';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-project-search-dialog',
  templateUrl: './project-search-dialog.component.html',
  styleUrls: ['./project-search-dialog.component.less']
})
export class ProjectSearchDialogComponent implements OnInit {
  projects: Array<Project>;
  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject<any>();
  isLoadingProjects: boolean;

  constructor(private service: FacadeService, @Inject(MAT_DIALOG_DATA) public data: {customerNo: string}, public dialogRef: MatDialogRef<ProjectSearchDialogComponent>) {
    this.isLoadingProjects = true;
  }

  ngOnInit(): void {
    this.dtOptions = {
      order: [[2, 'desc']],  
      columnDefs: [
        {targets: [2], orderData: [3]},
        {targets: [ 3 ], visible: false, searchable: false}
      ]
    };
    
    this.service.productService.GetProjects(this.data.customerNo).then((data: any) => {
      if(data.success) {
         this.projects = data.projects;
         this.dtTrigger.next();
         this.isLoadingProjects = false;
      }
    });
  }

  onCancel() : void{
    this.dialogRef.close();
  }

  formattedDate(date: string) : string {
    return moment(date).format("LL");
  }

  onProjectSelect(project: Project) : void {
    this.dialogRef.close(project);
  }
}
